import { gql } from '@apollo/client';
import BaseService from './baseService';

class ContactTypesService extends BaseService {
    // Override uri to point to dispatch Qore API
    constructor(uri) {
        super(uri);
        this.contactTypeGql = `
            contactTypeId
            contactType
        `;
    }
    
    async getContactTypes() {
        const CONTACT_TYPES = gql`
            query {
                dispatchContactTypes{
                    ${this.contactTypeGql}
                }
            }
        `;
            const result = await this.client.query({
                fetchPolicy: 'no-cache',
                query: CONTACT_TYPES,
            });
            if (result.data.dispatchContactTypes) {
                return result.data.dispatchContactTypes;
            } else {
                throw result.data.error;
            }
        }
}

const contactTypesService = new ContactTypesService(
    `${process.env.REACT_APP_DISPATCH_QORE_API}/graphql`
);

export default contactTypesService;
